module.exports = __webpack_public_path__ + "img/velliv-foreningen-logotype-primary-orange-rgb.13bb7bf4.svg";